import { useTranslate } from "ra-core";
import { ArrayInput } from "@/components/admin/array-input";
import { SimpleFormIterator } from "@/components/admin/simple-form-iterator";
import { TextInput } from "@/components/admin/text-input";
import { Card, CardContent } from "@/components/ui/card";

import type { FIT_LIST_FIELDS } from "./fit";

// lists are edited one item per line
const toLines = (items?: string[]) => (items ?? []).join("\n");
const fromLines = (text: string) => text.split("\n");

const field = (name: string) => `resources.fit.profile_fields.${name}`;

/** Settings (admin): ideal customer profiles for the fit score */
export const IdealCustomerSettings = () => {
  const translate = useTranslate();
  return (
    <Card id="ideal-customers">
      <CardContent className="space-y-4">
        <h2 className="text-xl font-semibold text-muted-foreground">
          {translate("resources.fit.profiles")}
        </h2>
        <p className="text-sm text-muted-foreground">
          {translate("resources.fit.profiles_help")}
        </p>
        <ArrayInput source="ideal_customers" label={false} helperText={false}>
          <SimpleFormIterator disableReordering disableClear>
            <TextInput source="name" label={field("name")} />
            <TextInput source="offer" label={field("offer")} multiline />
            <TextInput
              source="customer_problem"
              label={field("customer_problem")}
              multiline
            />
            <TextInput source="target_role" label={field("target_role")} />
            <TextInput
              source="target_geography"
              label={field("target_geography")}
            />
            <TextInput
              source="target_company_size"
              label={field("target_company_size")}
            />
            <ListInput source="positive_criteria" />
            <ListInput source="negative_criteria" />
            <ListInput source="example_clients" />
          </SimpleFormIterator>
        </ArrayInput>
      </CardContent>
    </Card>
  );
};

const ListInput = ({
  source,
}: {
  source: (typeof FIT_LIST_FIELDS)[number];
}) => {
  const translate = useTranslate();
  return (
    <TextInput
      source={source}
      label={field(source)}
      helperText={translate("resources.fit.one_per_line")}
      multiline
      format={toLines}
      parse={fromLines}
    />
  );
};
